module.exports = __webpack_public_path__ + "img/59.5d862a6b.jpg";